import { Injectable } from '@angular/core';

export interface IconDefinition {
  name: string;
  data: string;
}

/**
 * Service to register and manage SVG icon definitions.
 * This allows for tree-shaking - only icons that are registered will be included in the bundle.
 */
@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  private icons = new Map<string, string>();

  registerIcon(name: string, svgData: string): void {
    this.icons.set(name, svgData);
  }

  registerIcons(icons: IconDefinition[]): void {
    icons.forEach(({ name, data }) => {
      this.icons.set(name, data);
    });
  }

  getIcon(name: string): string | undefined {
    return this.icons.get(name);
  }
  hasIcon(name: string): boolean {
    return this.icons.has(name);
  }

  getRegisteredIcons(): string[] {
    return Array.from(this.icons.keys());
  }

  isIconRegistered(name: string): boolean {
    return this.icons.has(`${name}-bold`) || this.icons.has(name);
  }
}
